
const ANNOUNCEMENT_FORM_ROOT = '/announcement-form';

export const ANNOUNCEMENT_FORM_PATHS = {
    create: `${ANNOUNCEMENT_FORM_ROOT}/create`,
    confirmation: `${ANNOUNCEMENT_FORM_ROOT}/create/confirmation`,
    list: `${ANNOUNCEMENT_FORM_ROOT}/list`,
    update: `${ANNOUNCEMENT_FORM_ROOT}/update`
} as const;

export { RECIPIENT_PATHS } from 'shared-frontend';
